import { render } from "./ServerStatsStandalone.vue?vue&type=template&id=76b0a592&scoped=true"
import script from "./ServerStatsStandalone.vue?vue&type=script&lang=js"
export * from "./ServerStatsStandalone.vue?vue&type=script&lang=js"

import "./ServerStatsStandalone.vue?vue&type=style&index=0&id=76b0a592&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b0a592"]])

export default __exports__